import { useState } from 'react';
import { Mail, X } from 'lucide-react';
import { Button } from '../ui/button';
import api from '../../lib/api';

export const ResendPdfEmail = ({ order, disabled, onSent }) => {
  const [confirm,setConfirm]=useState(false),[busy,setBusy]=useState(false),[error,setError]=useState(''),[message,setMessage]=useState('');
  const resend=async()=>{
    setBusy(true);setError('');setMessage('');
    try {
      await api.post(`/pdf-shop/admin/orders/${order.id}/retry-email`);
      setMessage('E-mail accepté par Resend. La livraison peut être vérifiée séparément.');setConfirm(false);await onSent();
    } catch(e) {setError(typeof e.response?.data?.detail==='string'?e.response.data.detail:'Le renvoi a échoué.');}
    finally {setBusy(false);}
  };
  return <div className="pdf-resend-email">
    <Button size="sm" variant="outline" data-testid={`pdf-email-retry-${order.id}`} disabled={disabled||busy||order.status!=='paid'} onClick={()=>{setConfirm(true);setError('');setMessage('');}}><Mail size={14}/>Renvoyer l’e-mail</Button>
    {order.email_status==='failed'&&order.email_error_message&&<p className="pdf-error" data-testid={`pdf-email-last-error-${order.id}`}>{order.email_error_message}</p>}
    {confirm&&<div className="pdf-resend-confirm" role="alertdialog" aria-label="Confirmer le renvoi de l’e-mail" data-testid={`pdf-email-confirm-${order.id}`}>
      <p>Renvoyer le lien personnel à <strong>{order.email}</strong> ? L’expiration et le nombre de téléchargements ne seront pas réinitialisés.</p>
      <Button size="sm" disabled={busy} data-testid={`pdf-email-confirm-send-${order.id}`} onClick={resend}>{busy?'Envoi…':'Confirmer le renvoi'}</Button>
      <Button size="sm" variant="outline" disabled={busy} data-testid={`pdf-email-confirm-cancel-${order.id}`} onClick={()=>setConfirm(false)}><X size={14}/>Annuler</Button>
    </div>}
    {error&&<p role="alert" className="pdf-error" data-testid={`pdf-email-resend-error-${order.id}`}>{error}</p>}
    {message&&<p role="status" data-testid={`pdf-email-resend-success-${order.id}`}>{message}</p>}
  </div>;
};